class DataLayer {
  register = (key, value) => {
    if(window["dataLayer"]) {
        window["dataLayer"][key] = value;
    }
  }

  transformString = (value) => {
    switch ( value ) {
        case 'da':
            return 'denmark';
        case 'no':
            return 'norway';
        case 'fi':
            return 'finland';
        case 'sv':
            return 'sweden';
    }

    return value;
  }

}

var dataLayer = new DataLayer();
export default dataLayer;